import { ProfileFormData } from "./ProfileFormData";

export class PersonalInfoFormData extends ProfileFormData {
    constructor(_applicantId: number, _pageId:string) {
        super(_applicantId,_pageId);
    }

    FirstName?: string;
    MiddleName?: string;
    LastName?: string;
    MaidenName?: string;
    DateOfBirth?: string; // used by forms
    DOB?: string; // legacy alias
    Gender?: string;
    AmSexId?: string; // legacy alias
    MaritalStatus?: string;
    AmMaritalID?: string;
    HispanicOrLatino?: string;
    RaceDescription?: string;
    AmCitizenID?: string;
    Phone?: string;
    PhoneConfirm?: string;

    toJSON() {
        return {
            applicantId: this.applicantId,
            pageId: this.pageId,
            FirstName: this.FirstName,
            MiddleName: this.MiddleName,
            LastName: this.LastName,
            MaidenName: this.MaidenName,
            DateOfBirth: this.DateOfBirth ?? this.DOB,
            Gender: this.Gender ?? this.AmSexId,
            MaritalStatus: this.MaritalStatus ?? this.AmMaritalID,
            HispanicOrLatino: this.HispanicOrLatino,
            RaceDescription: this.RaceDescription,
            AmCitizenID: this.AmCitizenID,
            Phone: this.Phone,
            PhoneConfirm: this.PhoneConfirm,
        };
    }
}
